export default __webpack_public_path__ + "images/ac1d1020a217f37356373779f55106f9.png";